/**
 * Pricetable select script
 */
class Bookero_Pricetable {
  constructor() {
      this.initState();
  }

  initState () {
    this.pricetableWrappers = $('.block-pricetable');

    for (let i = 0; i < this.pricetableWrappers.length; i++) {
      this.initEvents(this.pricetableWrappers.eq(i));
    }
  }

  initEvents (wrapper) {
    let pricetableSelect = wrapper.find('.pricetable-select > select')[0];
    let pricetableTabcontent = wrapper.find('.pricetable-wrapper');

    for (let i = 0; i < pricetableTabcontent.length; i++) {
      pricetableTabcontent.eq(0).addClass('is-active');
    }

    easydropdown(pricetableSelect, {
      callbacks: {
        onSelect: value => {
          value = value.replace(/[^a-z0-9\-]/gmi, '');
          wrapper.find('.pricetable-wrapper').removeClass('is-active');
          wrapper.find('.pricetable-wrapper[data-table="' + value + '"]').addClass('is-active');
        }
      }
    })
  }
}